import { render } from "./MainPageComponent.vue?vue&type=template&id=49a7b18e&scoped=true"
import script from "./MainPageComponent.vue?vue&type=script&lang=js"
export * from "./MainPageComponent.vue?vue&type=script&lang=js"

import "./MainPageComponent.vue?vue&type=style&index=0&id=49a7b18e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a7b18e"]])

export default __exports__